module.exports = __webpack_public_path__ + "img/rs_whiteP-patch2.3a988b5.png";